module.exports = __webpack_public_path__ + "static/media/apartment22.260c3a6e.jpg";